import { watch, type Ref } from 'vue'
import { classifyRoundIndexChange } from './classifyRoundIndexChange'

export interface LiveBookmarkTrackerOptions {
  positionInitialized: Ref<boolean>
  currentLegoId: () => string | null | undefined
  cycleIndex: () => number
  persist: (cycle: number | undefined, touchPracticedAt?: boolean) => void
}

/**
 * Persists the live bookmark on each roundIndex change, telling a real round
 * advance (cycle 0, practice stamp) from earlier rounds being inserted in
 * front of the live one (keep the live cycle, no stamp; job #812).
 *
 * The LEGO the classifier compares against is seeded the instant init
 * completes (sync flush), before any async previous-round insertion can land.
 * Without the seed, a bootstrap that never changes roundIndex leaves it null
 * and the first insertion reads as a new round, wiping the bookmark to cycle 0.
 */
export function createLiveBookmarkTracker(o: LiveBookmarkTrackerOptions) {
  let lastLegoId: string | null = null
  watch(o.positionInitialized, (init) => {
    if (init) lastLegoId = o.currentLegoId() ?? null
  }, { flush: 'sync' })
  return {
    onRoundIndexChange() {
      const legoId = o.currentLegoId() ?? null
      const shift = classifyRoundIndexChange(lastLegoId, legoId) === 'index-shift'
      lastLegoId = legoId
      if (!o.positionInitialized.value) return
      if (shift) o.persist(o.cycleIndex(), false)
      else o.persist(0)
    },
  }
}
